<template>
  <div class="Building-page">
    <iframe
      class="iw-html-frame"
      scrolling="no"
      src="https://www.720yun.com/vr/0cdjtskavn1"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/Building.vue